import { DndContext, KeyboardSensor, PointerSensor, closestCorners, useDroppable, useSensor, useSensors } from "@dnd-kit/core";

import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { SortableField } from "./SortableField";


export default function Canvas({ handleDragEnd, fields, handleMostrarModal, removerChildren, removerPadre, anadirHijos, editarChildren }) {
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const { setNodeRef } = useDroppable({
        id: 'root'
    });

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCorners}
            onDragEnd={handleDragEnd}
        >
            <SortableContext
                id={'root'}
                items={fields}
                strategy={verticalListSortingStrategy}
            >
                <div ref={setNodeRef} style={{ position: 'relative' }}>
                    {fields?.map((f, i) => (
                        <SortableField key={f.id} id={f.id} field={f} index={i} anadirHijos={anadirHijos} editarChildren={editarChildren} handleMostrarModal={handleMostrarModal} removerChildren={removerChildren} removerPadre={removerPadre} handleDragEnd={handleDragEnd} />
                    ))}
                </div>
            </SortableContext>
        </DndContext>

    );
}
